import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useEffect, useMemo } from 'react'
import { isOperator } from '../../../../../services/AccountService'
import { getRequests } from '../api/api'
import PaginationStore from '../stores/PaginationStore'
import { userInfoStore } from '../stores/UserInfoStore'
import { RequestsParams } from '../types/types'

export const REQUEST_CLARIFICATION_KEYS = {
  GET_CLARIFICATION_TABLE: 'get-request-clarification-table',
  GET_REQUEST_TABLE: 'get-request-table',
}

const initParams: Omit<RequestsParams, 'page' | 'size' | 'sort'> = {}
export const requestsPaginationStore = new PaginationStore(initParams)

export const useRequestsData = (filterStore: any) => {
  const { page, size, sort, setPage, setSelectedRow } = requestsPaginationStore

  const {
    statuses,
    address,
    categories,
    financialSourceIds,
    fullName,
    hasDuplicates,
    orderId,
    phone,
    reasonId,
    senderId,
    SenderGroupIds,
    installedFrom,
    dealerIds,
    isExpired,
    isSuspicious,
    authorId,
    district,
    from,
    installedTo,
    locality,
    namePartial,
    surnamePartial,
    territory,
    to,
    reportId,
  } = filterStore?.param ?? {}

  const { id: userId } = userInfoStore.info

  const params = useMemo(
    () => ({
      size,
      page,
      sort: sort ?? undefined,
      address,
      categories,
      financialSourceIds,
      fullName,
      hasDuplicates,
      orderId,
      phone,
      statuses,
      reasonId,
      senderId,
      SenderGroupIds,
      installedFrom,
      dealerIds,
      isExpired,
      isSuspicious,
      userId,
      authorId,
      district,
      from,
      installedTo,
      locality,
      namePartial,
      surnamePartial,
      territory,
      to,
      reportId,
    }),
    [
      size,
      page,
      sort,
      address,
      categories,
      financialSourceIds,
      fullName,
      hasDuplicates,
      orderId,
      phone,
      statuses,
      reasonId,
      senderId,
      SenderGroupIds,
      installedFrom,
      dealerIds,
      isExpired,
      isSuspicious,
      userId,
      authorId,
      district,
      from,
      installedTo,
      locality,
      namePartial,
      surnamePartial,
      territory,
      to,
      reportId,
    ]
  )

  useEffect(() => {
    setSelectedRow(null, 0)

    if (page !== 0) {
      setPage(0)
    }
  }, [
    address,
    categories,
    financialSourceIds,
    fullName,
    hasDuplicates,
    orderId,
    phone,
    sort,
    statuses,
    reasonId,
    senderId,
    SenderGroupIds,
    installedFrom,
    dealerIds,
    isExpired,
    isSuspicious,
    authorId,
    district,
    from,
    installedTo,
    locality,
    namePartial,
    surnamePartial,
    territory,
    to,
    reportId,
  ])

  return useQuery({
    queryKey: [REQUEST_CLARIFICATION_KEYS.GET_REQUEST_TABLE, params],
    queryFn: () =>
      getRequests({
        size,
        page,
        address,
        categories,
        financialSourceIds,
        fullName,
        hasDuplicates,
        orderId,
        phone,
        statuses,
        reasonId,
        senderId,
        SenderGroupIds,
        installedFrom,
        dealerIds,
        isExpired,
        isSuspicious,
        authorId,
        district,
        from,
        installedTo,
        locality,
        namePartial,
        surnamePartial,
        territory,
        to,
        reportId,
        sort: sort ?? undefined,
      }),
    placeholderData: keepPreviousData,
    enabled: () => !!userId && !!isOperator(),
  })
}
